<template>
  <!-- {{ currentZoom }}{{ currentCenter }} -->
  <div style="width: 100%">
    <h3 class="mt-2" style="font-weight: 500">{{ header }}</h3>
    <div class="mt-3" style="width: 100%; height: 300px">
      <l-map
        v-if="showMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 100%; width: 100%; border-radius: 30px"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-feature-group v-for="i in withTooltip" :key="i">
          <l-marker
            @click="innerClick(i.path)"
            :lat-lng="i.latLng"
            v-if="currentZoom == 14"
          >
            <l-tooltip :options="{ draggable: true, visible: true }">
              <div @click="innerClick">
                <ul style="list-style-type: none">
                  <li>
                    <b>{{ i.headerText }}</b>
                  </li>
                  <li>{{ i.detail }}</li>
                </ul>
              </div>
            </l-tooltip>
          </l-marker>
        </l-feature-group>
        <l-feature-group v-for="i in withTooltip3" :key="i">
          <l-marker
            v-if="currentZoom == 10.5"
            @click="changeDistrict2(i.headerText)"
            :lat-lng="i.latLng"
          >
            <l-tooltip :options="{ draggable: true, visible: true }">
              <div @click="innerClick">
                <ul style="list-style-type: none">
                  <li>
                    <h4>{{ i.headerText }}</h4>
                  </li>
                </ul>
              </div>
            </l-tooltip>
          </l-marker>
        </l-feature-group>
        <l-feature-group v-for="i in withTooltip2" :key="i">
          <l-marker
            v-if="currentZoom > 0"
            @click="changeProvince(i.headerText)"
            :lat-lng="i.latLng"
          >
            <l-tooltip :options="{ draggable: true, visible: true }">
              <div @click="innerClick">
                <ul style="list-style-type: none">
                  <li>
                    <h4>{{ i.headerText }}</h4>
                  </li>
                </ul>
              </div>
            </l-tooltip>
          </l-marker>
        </l-feature-group>
      </l-map>
    </div>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LTooltip,
  LFeatureGroup,
} from "vue2-leaflet";

export default {
  name: "Example",
  props: ["header"],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LFeatureGroup,
  },
  data() {
    return {
      zoom: 7,
      center: latLng(15.130964, 102.291493),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      // withTooltip: [latLng(47.41422, -1.250482), latLng(47.41322, -1.219482)],
      withTooltip: [
        {
          latLng: latLng(14.349782902583865, 100.66855178571203),
          path: "customdashboardRojana",
          headerText: "ENDEAVOR",
          detail: "42/35 หมู่ 4 ตำบลอุทัย อำเภออุทัย จังหวัดพระนครศรีอยุธยา",
        },
        {
          latLng: latLng(16.298715111053543, 102.79778136700233),
          path: "customdashboard",
          headerText: "KENDALL",
          detail:
            "121/16 หมู่ที่ 17 ตำบลท่าพระ อำเภอเมืองขอนแก่น จังหวัดขอนแก่น",
        },
        // {
        //   latLng: latLng(13.590496360333193, 100.75571002195952),
        //   path: "customdashboardBangplee",
        //   headerText: "UNICORN",
        //   detail:
        //     "88/173 หมู่ที่ 15 ตำบลบางเสาธง อำเภอบางเสาธง จังหวัดสมุทรปราการ",
        // },
      ],
      withTooltip2: [
        {
          latLng: latLng(14.349782902583865, 100.66855178571203),
          path: "customdashboardRojana",
          headerText: "จังหวัดพระนครศรีอยุธยา",
          detail: "42/35 หมู่ 4 ตำบลอุทัย อำเภออุทัย จังหวัดพระนครศรีอยุธยา",
        },
        {
          latLng: latLng(16.298715111053543, 102.79778136700233),
          path: "customdashboard",

          headerText: "จังหวัดขอนแก่น",
          detail:
            "121/16 หมู่ที่ 17 ตำบลท่าพระ อำเภอเมืองขอนแก่น จังหวัดขอนแก่น",
        },
        // {
        //   latLng: latLng(13.590496360333193, 100.75571002195952),
        //   path: "customdashboardBangplee",

        //   headerText: "จังหวัดสมุทรปราการ",
        //   detail:
        //     "88/173 หมู่ที่ 15 ตำบลบางเสาธง อำเภอบางเสาธง จังหวัดสมุทรปราการ",
        // },
      ],
      withTooltip3: [
        {
          latLng: latLng(14.349782902583865, 100.66855178571203),
          path: "customdashboardRojana",
          headerText: "อำเภออุทัย",
          detail: "42/35 หมู่ 4 ตำบลอุทัย อำเภออุทัย จังหวัดพระนครศรีอยุธยา",
        },
        {
          latLng: latLng(16.298715111053543, 102.79778136700233),
          path: "customdashboard",

          headerText: "อำเภอเมืองขอนแก่น",
          detail:
            "121/16 หมู่ที่ 17 ตำบลท่าพระ อำเภอเมืองขอนแก่น จังหวัดขอนแก่น",
        },
        // {
        //   latLng: latLng(13.590496360333193, 100.75571002195952),
        //   path: "customdashboardBangplee",

        //   headerText: "อำเภอบางเสาธง",
        //   detail:
        //     "88/173 หมู่ที่ 15 ตำบลบางเสาธง อำเภอบางเสาธง จังหวัดสมุทรปราการ",
        // },
      ],
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      provinceList: [
        {
          name: "จังหวัดสมุทรปราการ",
          zoom: 10.5,
          lat: 13.615706,
          lng: 100.823278,
        },
        {
          name: "จังหวัดพระนครศรีอยุธยา",
          zoom: 10.5,
          lat: 14.381719,
          lng: 100.777638,
        },
        { name: "จังหวัดขอนแก่น", zoom: 10.5, lat: 16.457862, lng: 102.747926 },
      ],
      provinceList2: [
        { name: "อำเภอบางเสาธง", zoom: 14, lat: 13.591307, lng: 100.792222 },
        { name: "อำเภออุทัย", zoom: 14, lat: 14.355244, lng: 100.679955 },
        {
          name: "อำเภอเมืองขอนแก่น",
          zoom: 14,
          lat: 16.311944,
          lng: 102.810874,
        },
      ],
    };
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick(item) {
      console.log(item);
      if (item == 'customdashboardRojana') {
        this.$router.push('/Stock/Dashboard/Warehouse?id=1');
      }else{
        this.$router.push('/Stock/Dashboard/Warehouse?id=2');
      }
    },
    zoomIn() {
      this.zoom += 1.5;
      // this.centerUpdate(this.currentZoom);
    },
    changeDistrict2(name) {
      let filter = this.provinceList2.filter((x) => x.name == name);
      filter = filter[0];
      console.log(filter);
      this.zoom = filter.zoom;
      setTimeout(() => {
        this.center = latLng(filter.lat, filter.lng);
      }, 500);
    },
    changeProvince(name) {
      let filter = this.provinceList.filter((x) => x.name == name);
      filter = filter[0];
      console.log(filter);
      this.zoom = filter.zoom;
      setTimeout(() => {
        this.center = latLng(filter.lat, filter.lng);
      }, 500);
    },
  },
};
</script>